export const FETCH ="Fetch";
export const AUTH ="SignUp";
export const LEAD_DATA = "LeaderBoardData";
export const LOGOUT = "Logout";
export const CHECK = "Check";
export const PROF = "Profile";
export const OPP_PROF = "OpponentProfile";
export const UPDATE_PROF = "UpdatedProfile";
export const UPDATE_IMG = "UpdatedProfileImage";
export const CREATE_ROOM = "CreateRoomPlayer";
export const JOIN_ROOM = "JoinRoomPlayer";
export const FETCH_ROOM = "FetchRoomPlayers";
export const CUT_NUM = "CutNum";